"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _Carousel = _interopRequireDefault(require("../../darkmatter/Carousel"));

var _IndicatorGroup = _interopRequireDefault(require("./components/IndicatorGroup"));

var _CarouselArrow = _interopRequireDefault(require("./components/CarouselArrow"));

var _ImageGrid = _interopRequireDefault(require("./components/ImageGrid"));

require("./ImageCollection.css");

var ImageCollection = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ImageCollection, _React$Component);

  function ImageCollection() {
    (0, _classCallCheck2["default"])(this, ImageCollection);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ImageCollection).apply(this, arguments));
  }

  (0, _createClass2["default"])(ImageCollection, [{
    key: "createImageRows",
    value: function createImageRows() {
      var _this$props = this.props,
          numberOfRowDisplayItems = _this$props.numberOfRowDisplayItems,
          images = _this$props.images,
          cutUnevenRows = _this$props.cutUnevenRows;

      if (images.length < numberOfRowDisplayItems) {
        return [images];
      }

      var groupedImages = images.reduce(function (acc, _, i) {
        return i % numberOfRowDisplayItems ? acc : [].concat((0, _toConsumableArray2["default"])(acc), [images.slice(i, i + numberOfRowDisplayItems)]);
      }, []);

      if (cutUnevenRows) {
        return groupedImages.filter(function (group) {
          return group.length === numberOfRowDisplayItems;
        });
      }

      return groupedImages;
    }
  }, {
    key: "renderCarousel",
    value: function renderCarousel() {
      var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
          images = _this$props2.images,
          numberOfRowDisplayItems = _this$props2.numberOfRowDisplayItems,
          disable = _this$props2.disable,
          carouselOptions = _this$props2.carouselOptions;
      var numberOfRowDisplayItemsOR = overrides.numberOfRowDisplayItemsOR,
          disableOR = overrides.disableOR;
      var finalDisable = disableOR || disable;
      var finalNumberOfRowDisplayItems = numberOfRowDisplayItemsOR || numberOfRowDisplayItems;
      var autoScroll = carouselOptions.autoScroll,
          autoScrollTime = carouselOptions.autoScrollTime;
      return _react["default"].createElement(_Carousel["default"], {
        totalNumberOfItems: images.length,
        autoScroll: autoScroll,
        autoScrollTime: autoScrollTime,
        numberOfDisplayItems: finalNumberOfRowDisplayItems > images.length ? images.length : finalNumberOfRowDisplayItems
      }, function (_ref) {
        var currentIndex = _ref.currentIndex,
            changeCurrentIndex = _ref.changeCurrentIndex,
            getDisplayItemIndices = _ref.getDisplayItemIndices;
        return _react["default"].createElement("div", {
          style: {
            margin: 'auto',
            textAlign: 'center'
          }
        }, _react["default"].createElement(_ImageGrid["default"], {
          imageGroups: [getDisplayItemIndices().map(function (index) {
            return images[index];
          })],
          rightArrow: finalDisable !== 'arrows' && finalDisable !== 'both' && _react["default"].createElement(_CarouselArrow["default"], {
            orientation: "right",
            onToggle: changeCurrentIndex,
            currentIndex: currentIndex
          }),
          leftArrow: finalDisable !== 'arrows' && finalDisable !== 'both' && _react["default"].createElement(_CarouselArrow["default"], {
            orientation: "left",
            onToggle: changeCurrentIndex,
            currentIndex: currentIndex
          })
        }), finalDisable !== 'indicators' && finalDisable !== 'both' && _react["default"].createElement(_IndicatorGroup["default"], {
          images: images,
          currentIndex: currentIndex,
          changeCurrentIndex: changeCurrentIndex
        }));
      });
    }
  }, {
    key: "renderGallery",
    value: function renderGallery() {
      var imageGroups = this.createImageRows();
      return _react["default"].createElement(_ImageGrid["default"], {
        imageGroups: imageGroups
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          as = _this$props3.as,
          centered = _this$props3.centered,
          header = _this$props3.header,
          className = _this$props3.className,
          ignoreMobileCarousel = _this$props3.ignoreMobileCarousel;
      return _react["default"].createElement("div", {
        className: className,
        style: centered ? {
          margin: 'auto',
          textAlign: 'center'
        } : {}
      }, header && _react["default"].createElement(_semanticUiReact.Header, {
        as: "h1"
      }, header), _react["default"].createElement("span", {
        className: "desktop"
      }, as === 'gallery' ? this.renderGallery() : this.renderCarousel()), _react["default"].createElement("span", {
        className: "mobile"
      }, ignoreMobileCarousel ? this.renderGallery() : this.renderCarousel({
        numberOfRowDisplayItemsOR: 1,
        disable: 'none'
      })));
    }
  }]);
  return ImageCollection;
}(_react["default"].Component);

exports["default"] = ImageCollection;
ImageCollection.propTypes = {
  carouselOptions: _propTypes["default"].shape({
    autoScroll: _propTypes["default"].bool,
    autoScrollTime: _propTypes["default"].number
  }),
  as: _propTypes["default"].oneOf(['carousel', 'gallery']),
  centered: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  cutUnevenRows: _propTypes["default"].bool,
  disable: _propTypes["default"].oneOf(['none', 'indicators', 'arrows', 'both']),
  header: _propTypes["default"].string,
  images: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  numberOfRowDisplayItems: _propTypes["default"].number,
  ignoreMobileCarousel: _propTypes["default"].bool
};
ImageCollection.defaultProps = {
  as: 'gallery',
  carouselOptions: {
    autoScroll: undefined,
    autoScrollTime: undefined
  },
  centered: false,
  className: '',
  cutUnevenRows: true,
  disable: 'none',
  header: '',
  numberOfRowDisplayItems: 3,
  ignoreMobileCarousel: false
};
ImageCollection.propOptions = {};
ImageCollection.dataPropsMap = {
  images: ['business', 'gallery_images']
};